import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiV6Service } from '@service/apiv6.service';
import { RequestTools } from '@service/request.tools';
import {
    concatAllBasket,
    storeData,
    addBasketColor,
    getColorName,
    getInternalPrefUsr,
} from '@core/_utils/tools.utils';
import { MessagesService } from '@core/_services/messages.service';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { CommonService } from '@service/common.service';
import { ConfirmationService, FilterService } from 'primeng/api';
import { ItemConfirmComponent } from '../_components/item-confirm/item-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'page-basket-param',
    styleUrls: ['./page-basket-param.component.scss'],
    templateUrl: './page-basket-param.component.html',
})
export class PageBasketParamComponent implements OnInit, OnDestroy {
    public itemConfirm: ItemConfirmComponent;
    private basketMailList: any;
    private basketCollectList: any;
    private basketPublishList: any;
    private basketActionList: any;
    private basketInputList: any;
    private basketOutputList: any;
    private basketSystemList: any;
    public basketAll: any[];
    public title: string;
    public displaySearch: boolean = false;
    public error = false;
    public errorMessage = '';
    public displayColor: boolean = false;
    public colorList: any[];

    public currentfilterName: string = '';
    public basketAllWrk: any[];
    public filterName: string = '';
    public currentColor: string;
    private intern: any;
    public internalPrefUsr: any;

    constructor(
        public confirmationService: ConfirmationService,
        protected _messageService: MessagesService,
        private api: ApiV6Service,
        private requestTools: RequestTools,
        public menu: MenuServiceInt,
        private commonService: CommonService,
        private filterService: FilterService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.basketAllWrk = new Array();
        this.colorList = [];
    }

    public ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.getBasketList();
        this.commonService.checkReset();
        this.intern = JSON.parse(atob(localStorage.getItem('intern')));
        this.internalPrefUsr = getInternalPrefUsr();        
        this.setFilter();
    }

    public ngOnDestroy() {
    }

    private async getBasketList() {
        let wRes: any;
        this.title = this.translate.instant('Bsk_List');
        this.init();
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getbskcolorlist', ''));
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        wRes.data.forEach((item) => {
            this.colorList[item.id] = item.color;
        });

        wRes = await this.requestTools.getBasketList('');
        if (wRes.Status !== 'OK') {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        } else {
            this.basketMailList = wRes.BasketMailList.BasketMail;
            this.basketCollectList = wRes.BasketCollectList.BasketCollect;
            this.basketPublishList = wRes.BasketPublishList.BasketPublish;
            this.basketActionList = wRes.BasketActionList.BasketAction;
            this.basketInputList = wRes.BasketInputList.BasketInput;
            this.basketOutputList = wRes.BasketOutputList.BasketOutput;
            this.basketSystemList = wRes.BasketSystemList.BasketSystem;

            this.basketAll = concatAllBasket(
                this.basketMailList,
                this.basketCollectList,
                this.basketPublishList,
                this.basketActionList,
                this.basketInputList,
                this.basketOutputList,
                this.basketSystemList
            );         
        }
    }
    
    public onSelBasket($event, aBsk) {
        $event.stopPropagation();
        aBsk.Information.isSelected = !aBsk.Information.isSelected;
        if (aBsk.Information.isSelected === true) {            
            this.currentColor = this.getCurrentColor(this.colorList[aBsk.Information.Name], aBsk.Information.basketType);
        }
    }

    private getCurrentColor(aColor, aBskType ) {
        let wColor = aColor;
        if (wColor === undefined) {
            wColor = this.getDefaultColor(aBskType);
        }
        return wColor;
    }

    private getDefaultColor(aBskType) {
        switch (aBskType) {
            case 'btMail':
                return this.intern.bskMailColor;
            case 'btCollect':
                return this.intern.bskCollectColor;
            case 'btPublish':
                return this.intern.bskPublishColor;
            case 'btAction':
                return this.intern.bskActionColor;
            case 'btInput':
                return this.intern.bskInputColor;
            case 'btOutput':
                return this.intern.bskOutputColor;
            case 'btSystem': 
                return this.intern.bskSystemColor;
            default: 
                return this.intern.bskSystemColor;
        }
    }

    public onClickColor() {
        this.displayColor = true;
    }

    public onClickReinitColor() {
        this.displayColor = true;
    }

    public closeColor() {
        this.displayColor = false;
    }

    public confirmInitialize() {
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_Colr'),
            () => {
                this.prepareInitialize();
            }
        );
    }

    public prepareInitialize() {
        const wData = this.prepareRequest(null, true);
        this.update(wData);
    }
    
    public saveColor() {
        this.displayColor = false;
        const wData = this.prepareRequest(this.currentColor, false);
        if (wData.updatelist.length === 0) {
            this._messageService.addWarnNoStick(this.translate.instant('Bsk_Empty_1'));
            return;
        }
        this.update(wData);
    }

    private async update(aData) {
        let wRes;
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('setbskcolor', aData));
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Update_KO'));
            return;
        }
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('getbskcolorlist', ''));
            storeData('bskcolorlist', JSON.stringify(wRes.data));
            if (aData.initialize === true) {
                this.initializeColor();
            } else {
                this.updateColor(aData);        
            }
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }
    
    private initializeColor() {
        this.setBasketColor(this.basketCollectList,this.intern.bskCollectColor);    
        this.setBasketColor(this.basketMailList,this.intern.bskMailColor);
        this.setBasketColor(this.basketPublishList,this.intern.bskPublishColor);    
        this.setBasketColor(this.basketActionList,this.intern.bskActionColor);    
        this.setBasketColor(this.basketInputList,this.intern.bskInputColor);    
        this.setBasketColor(this.basketOutputList,this.intern.bskOutputColor);    
        this.setBasketColor(this.basketSystemList,this.intern.bskSystemColor); 
    }

    private setBasketColor(aBskList, aDefColor) {
        aBskList.map((item) => {
            addBasketColor(item.Information.color, aDefColor);            
        })
    }

    private updateColor(aData) {
        let wId;        
        aData.updatelist.forEach(item => {
            wId = getColorName(item.id);
            addBasketColor(wId, item.color);
        })
    }

    private prepareRequest(aCurrentColor, aInitialize) {
        let wRequestList = [];
        let wRequestData: any;
        if (aInitialize === false) {
            this.basketAll.forEach((item) => {
                if (item.Information.isSelected === true) {
                    wRequestData = {
                        id: item.Information.Name,
                        login: '',
                        color: aCurrentColor,
                    };
                    wRequestList.push(wRequestData);       
                }
            });
        }
        wRequestData = {
            updatelist: wRequestList,
            initialize: aInitialize
        };
        return wRequestData;
    }

    public filter(aValue) {
        this.basketAll = concatAllBasket(
            this.basketMailList,
            this.basketCollectList,
            this.basketPublishList,
            this.basketActionList,
            this.basketInputList,
            this.basketOutputList,
            this.basketSystemList
        );           
        this.basketAll = this.filterService.filter(this.basketAll, ['Information.Label'] , aValue, 'contains');
    }

    private setFilter() {
        const customFilterName = 'custom-find';    
        this.filterService.register(customFilterName, (value, filter): boolean => {
            if (filter === undefined || filter === null || filter.length === 0) {
                return true;
            }    
            if (value === undefined || value === null) {
                return false;
            }
            for (let item of filter) {
                if (value.indexOf(item.code) !== -1) {
                    return true;
                }
            }
            return false;
        });
    }
    
    private init() {
        this.basketMailList = null;
        this.basketCollectList = null;
        this.basketPublishList = null;
        this.basketActionList = null;
        this.basketInputList = null;
        this.basketOutputList = null;
        this.basketSystemList = null;
    }

    public handleChange($event) {}
}
